import React, { createContext, useContext, useState } from 'react';

const GuidedPracticeContext = createContext();

function GuidedPracticeProvider({ children }) {
  const [guidedPractice, setGuidedPractice] = useState(null);
  const [showGuidedPracticeTutorialModal, setShowGuidedPracticeTutorialModal] = useState(false);

  return (
    <GuidedPracticeContext.Provider
      value={{
        guidedPractice,
        setGuidedPractice,
        showGuidedPracticeTutorialModal,
        setShowGuidedPracticeTutorialModal,
      }}
    >
      {children}
    </GuidedPracticeContext.Provider>
  );
}

function useGuidedPracticeProvider() {
  const context = useContext(GuidedPracticeContext);
  if (context === undefined) {
    throw new Error('useGuidedPracticeProvider must be used within GuidedPracticeProvider');
  }
  return context;
}

export { useGuidedPracticeProvider };
export default GuidedPracticeProvider;
